import request from "@utils/request";
import { ParamsProps, ReturnType } from "./types";

const EmailTemplates = {
  list: async (args: ParamsProps) => {
    const config: ReturnType = {
      url: "email-templates",
      method: "get",
      authorization: true,
      params: args?.params,
      config: {
        showErr: true,
        store: args?.state ? { key: args.state, action: "set" } : undefined,
      },
    };
    return await request(config);
  },
  getOne: async (args: ParamsProps) => {
    const { type, event } = args as any;
    const config: ReturnType = {
      url: `email-templates/${type}/${event}`,
      method: "get",
      authorization: true,
      config: { showErr: true },
    };
    return await request(config);
  },
  upsert: async (args: ParamsProps) => {
    const config: ReturnType = {
      url: "email-templates",
      method: "post",
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: "Template saved successfully",
      },
    };
    return await request(config);
  },
  update: async (args: ParamsProps) => {
    const config: ReturnType = {
      url: `email-templates/update/${args.id}`,
      method: "post",
      data: args?.data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: "Template updated successfully",
      },
    };
    return await request(config);
  },
  remove: async (args: ParamsProps) => {
    const config: ReturnType = {
      url: `email-templates/${args.id}`,
      method: "delete",
      authorization: true,
      config: {
        showErr: true,
        successMsg: "Template deleted successfully",
      },
    };
    return await request(config);
  },
};

export default EmailTemplates;
